import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import backend from 'i18next-http-backend';

i18n
  .use(backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-GB',
    lng: navigator.language,
    ns: ["TS_core","TS_temp"],
    nsSeparator:':',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
  }).then(()=>{
    console.log("All Translations Loaded!")
  }).catch((err)=>{
    console.log(err);
    console.log("Translations Failed!")
  });

export default i18n;
